import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "flex-fill text-truncate" }
const _hoisted_4 = { class: "mr-2" }
const _hoisted_5 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_6 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_7 = { class: "pl-2 pr-1 link" }
const _hoisted_8 = {
  key: 0,
  class: "pl-2 pr-1 link"
}
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "side-menu-field-descr" }

import SideMenuCardSection from "~/operatorApplication/vue/dialogs/dialog/sidemenu/SideMenuCardSection.vue";
import SideMenuCard from "~/operatorApplication/vue/dialogs/dialog/sidemenu/SideMenuCard.vue";
import {computed, ref} from "vue";
import ReactiveRequest from "~/core-ui/ts/request/ReactiveRequest";
import ReactiveRequestLoader from "~/cabinet/vue/interface/data/ReactiveRequestLoader.vue";
import OperatorApplicationPlatformIcon from "~/operatorApplication/vue/misc/OperatorApplicationPlatformIcon.vue";
import {__} from "~/ts/library/Translate";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import MyLoader from "~/cabinet/vue/interface/data/MyLoader.vue";
import OperatorApiRequestFactory from "~/operatorApplication/ts/request/OperatorApiRequestFactory";
import ElConfirm from "~/core-ui/vue/ui/ElConfirm";
import OperatorApplicationPlatform from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import OperatorApplicationHtmlify from "~/operatorApplication/vue/misc/OperatorApplicationHtmlify.vue";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import Dictionary from "~/ts/library/Dictionary";
import DataProviderLogDialog
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/dataProvider/log/DataProviderLogDialog.vue";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "DataProviderEntityCard"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    username: {},
    historyItem: {},
    entityType: {},
    platform: {},
    isEditAvailable: { type: Boolean }
  },
  emits: ["edit"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

let menuItems: Dictionary<{
    descr: string,
    icon: string,
    callback: () => void
}> = {
    logs: {
        descr: __('Логи'),
        icon: 'scroll',
        callback: openLog
    },
    edit: {
        descr: __('Редактировать'),
        icon: 'pencil',
        callback: () => emits('edit')
    },
    remove: {
        descr: __('Отвязать'),
        icon: 'link-slash',
        callback: () => remove()
    }
}

let isOpened = ref(false);

let isLoadEntityAvailable = computed(() => OperatorAccountStore.data.value.accessRights.canLoadDataProviderEntity && props.entityType.isFetchAvailable);

function getGetEntityByIdParams() {
    let item = props.historyItem;
    let p: OperatorApplicationApi.OperatorDataProviderGetEntityByIdOpenApiModel = {
        username: props.username,
        platformId: item.platformId,
        authPrimaryId: item.authPrimaryId,
        entityTypeId: item.entityTypeId,
        entityId: item.entityId
    };
    return p;
}

async function remove(errorDescr?: string) {
    let message = `Удалить запись об этой сущности из данных клиента?`;
    if (errorDescr) {
        message = `${errorDescr}\n\n${message}`;
    }
    await ElConfirm(message);
    let deleteParams: OperatorApplicationApi.OperatorDataProviderDeleteEntityFromClientHistoryByIdOpenApiModel = getGetEntityByIdParams();
    await OperatorApiRequestFactory.create<OperatorApplicationApi.OperatorDataProviderGetEntityByIdResultOpenApiModel>({
        url: "/dataProvider/deleteEntityFromClientHistoryById",
        p: deleteParams
    }).save();
}

let request = computed(() => {
    if (isOpened.value) {
        let item = props.historyItem;
        let p = getGetEntityByIdParams();

        return (new ReactiveRequest(OperatorApiRequestFactory.create<OperatorApplicationApi.OperatorDataProviderGetEntityByIdResultOpenApiModel>({
            url: "/dataProvider/getEntityById",
            p,
            silent: true
        }))).setShowErrorMessage(false).setErrorCallback(async function (result) {
            isOpened.value = false;
            if (result) {
                if (result.code === 404) {
                    try {
                        await remove(result.descr);
                    } catch (e) {

                    }
                } else {
                    result.showMessage();
                }
            }
        });
        //return new ReactiveRequest(props.dataProviderGetEntityById(p))
    }
    return null;
});

let logDialogVisible = ref(false);

function openLog() {
    logDialogVisible.value = true;
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _directive_on_native = _resolveDirective("on-native")!
  const _directive_my_tooltip = _resolveDirective("my-tooltip")!

  return (_openBlock(), _createBlock(SideMenuCard, {
    margin: false,
    class: "mb-2 card"
  }, {
    default: _withCtx(() => [
      _createVNode(SideMenuCardSection, {
        class: "text-truncate",
        disabled: !_unref(isLoadEntityAvailable),
        "click-listening": "",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_isRef(isOpened) //@ts-ignore
 ? isOpened.value = !_unref(isOpened) : isOpened = !_unref(isOpened)))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              class: _normalizeClass({
                        'flex-fill min-width-0': true,
                        'font-weight-bold': !!(_unref(request) && _unref(request).data)
                    })
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("span", _hoisted_4, [
                    (_unref(request) && !_unref(request).data)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(MyLoader, { "without-style": "" }),
                          _createVNode(ReactiveRequestLoader, {
                            class: "d-none",
                            request: _unref(request)
                          }, null, 8, ["request"])
                        ], 64))
                      : (_openBlock(), _createBlock(OperatorApplicationPlatformIcon, {
                          key: 1,
                          platform: __props.platform
                        }, null, 8, ["platform"]))
                  ]),
                  _createTextVNode(" " + _toDisplayString(__props.entityType.descr) + " #" + _toDisplayString(__props.historyItem.entityId) + " ", 1),
                  (__props.historyItem.isCreateByCrm)
                    ? (_openBlock(), _createElementBlock("sup", _hoisted_5, _toDisplayString(_unref(__)("Создано из CRM")), 1))
                    : (__props.historyItem.isFoundInCrm)
                      ? (_openBlock(), _createElementBlock("sup", _hoisted_6, _toDisplayString(_unref(__)("Найдено в CRM")), 1))
                      : _createCommentVNode("", true)
                ]),
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_el_dropdown, {
                    trigger: "click",
                    onCommand: _cache[0] || (_cache[0] = ($event) => _unref(menuItems)[$event].callback())
                  }, {
                    dropdown: _withCtx(() => [
                      _createVNode(_component_el_dropdown_menu, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuItems), (item, key) => {
                            return (_openBlock(), _createBlock(_component_el_dropdown_item, { command: key }, {
                              default: _withCtx(() => [
                                _createVNode(FontAwesomeIcon, {
                                  icon: item.icon
                                }, null, 8, ["icon"]),
                                _createTextVNode(" " + _toDisplayString(item.descr), 1)
                              ]),
                              _: 2
                            }, 1032, ["command"]))
                          }), 256))
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("span", null, [
                        _createVNode(_component_el_button, {
                          link: "",
                          class: "pt-0 pb-0 h-auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(FontAwesomeIcon, { icon: "bars" })
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ])), [
                  [
                    _directive_on_native,
                    void 0,
                    "click",
                    { stop: true }
                  ]
                ]),
                (__props.historyItem.url)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _withDirectives((_openBlock(), _createElementBlock("a", {
                        href: __props.historyItem.url,
                        target: "_blank",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(OperatorApplicationPlatform).openExternal(__props.historyItem.url)), ["prevent","stop"]))
                      }, [
                        _createVNode(FontAwesomeIcon, { icon: "external-link" })
                      ], 8, _hoisted_9)), [
                        [_directive_my_tooltip, {text: _unref(__)('Открыть в браузере'), delay: 500}]
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 2)
          ])
        ]),
        _: 1
      }, 8, ["disabled"]),
      (_unref(request) && _unref(request).data)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(request).data.fields, (field) => {
            return (_openBlock(), _createBlock(SideMenuCardSection, {
              key: field.id,
              compact: "",
              class: _normalizeClass({
                    section: true
                })
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, _toDisplayString(field.descr), 1),
                _createElementVNode("div", null, [
                  _createVNode(OperatorApplicationHtmlify, {
                    value: _unref(request).data.entity[field.id],
                    nl2br: "",
                    links: "",
                    bbcode: ""
                  }, null, 8, ["value"])
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        : _createCommentVNode("", true),
      (_unref(logDialogVisible))
        ? (_openBlock(), _createBlock(DataProviderLogDialog, {
            key: 1,
            visible: _unref(logDialogVisible),
            "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_isRef(logDialogVisible) ? (logDialogVisible).value = $event : logDialogVisible = $event)),
            "platform-id": __props.historyItem.platformId,
            "auth-primary-id": __props.historyItem.authPrimaryId,
            "entity-type-id": __props.historyItem.entityTypeId,
            "entity-id": __props.historyItem.entityId,
            username: __props.username
          }, null, 8, ["visible", "platform-id", "auth-primary-id", "entity-type-id", "entity-id", "username"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})